import type { HostedRuntime as GraftHostedRuntime } from '@graft/nuget-gc.webportals.gateways'

import { HostedRuntime } from '../types/gateway.type'

export async function hostedRuntimeToObject(entity: GraftHostedRuntime): Promise<HostedRuntime> {
  const [id, name, version] = await Promise.all([entity.get_hostedRuntimeId(), entity.get_name(), entity.get_version()])

  return { id, name, version }
}
